import { Injectable } from '@angular/core';

import {
  EdgePostsSidePointsCalculationService,
  IResult
} from '../../edge-posts-sidePoints-calculation.service';

declare const THREE: any;

interface ISize {
  width: number;
  height: number;
}

interface ISettings {
  pointA: any;
  pointB: any;
  lightMeshSize: ISize;
  floorOffset: number;
  rayInfo?: { origin: any; direction: any };
}

@Injectable()
export class RailingLightArrangeService {
  private raycaster;

  constructor(private postsSidePointsCalculationService: EdgePostsSidePointsCalculationService) {
    this.raycaster = new THREE.Raycaster();
  }

  private static createLightMesh(length: number, width: number, height: number) {
    const geometry = new THREE.BoxGeometry(length, height, width);
    const material = new THREE.MeshBasicMaterial({ color: 0xffffff });
    const mesh = new THREE.Mesh(geometry, material);
    mesh.name = 'railLight';
    return mesh;
  }

  private arrangeLights(points: Array<IResult>, lightMeshSize: ISize) {
    const result = [];
    const offset = new THREE.Vector3();
    const { width, height } = lightMeshSize;

    points.forEach(line => {
      const { leftPoint, rightPoint } = line;
      const distanceBetweenPosts = leftPoint.distanceTo(rightPoint);
      offset
        .subVectors(rightPoint, leftPoint)
        .normalize()
        .multiplyScalar(distanceBetweenPosts / 2);
      const len95Percents = (distanceBetweenPosts * 95) / 100;
      const position = leftPoint.clone().add(offset);
      const lightMesh = RailingLightArrangeService.createLightMesh(len95Percents, width, height);
      lightMesh.position.copy(position);
      result.push(lightMesh);
    });

    return result;
  }

  arrange(settings: ISettings): any[] {
    const { pointA, pointB, floorOffset, rayInfo } = settings;
    const points = this.postsSidePointsCalculationService.getPoints({
      edgeStartPoint: pointA,
      edgeEndPoint: pointB,
      floorOffset,
      rayInfo
    });
    return this.arrangeLights(points, settings.lightMeshSize);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/light/railing-light-arrange.service.ts